import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import {
  CREATE_USER_NOTE_FAILURE,
  CREATE_USER_NOTE_REQUEST,
  CREATE_USER_NOTE_SUCCESS
} from "../types";
import { addEntities } from "../../entities";

export default (userId, note, attachment) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(createAction(CREATE_USER_NOTE_REQUEST)({}));
    const response = await api.user.createNote(userId, note, attachment);
    const data = normalize(response, schema.notes);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(CREATE_USER_NOTE_SUCCESS)({
        [userId]: [data.result]
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(CREATE_USER_NOTE_FAILURE)(err));
    throw err;
  }
};
